import { z } from 'zod';
import { CreateAsset, RequestAssetUpload } from '@robocorp/robocloud-asset-storage-interface';
import { UseTranslationResponse } from 'react-i18next';

export enum AssetContent {
  Text = 'text',
  Json = 'json',
  File = 'file',
}

export const mimeTypeToAssetContent: Record<string, AssetContent> = {
  'text/plain': AssetContent.Text,
  'application/json': AssetContent.Json,
};

export const getAssetContentFromMimeTypes = (contentType: string | undefined | null) => {
  if (!contentType) return AssetContent.File;
  return mimeTypeToAssetContent[contentType] ?? AssetContent.File;
};

export const supportedPreviewMimeTypes = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'application/json',
  'text/plain',
  'text/html',
  'application/pdf',
];

export const getAssetContentItems = ({
  t,
}: {
  t: UseTranslationResponse<string, undefined>['t'];
}) => [
  { value: AssetContent.Text, label: t('assetStorage.assetContent.text') },
  { value: AssetContent.Json, label: t('assetStorage.assetContent.json') },
  { value: AssetContent.File, label: t('assetStorage.assetContent.file') },
];

export const assetCreateSchema = CreateAsset.http.request.body.merge(
  z.object({
    assetContent: z.nativeEnum(AssetContent).default(AssetContent.Text),
  }),
);

export type AssetCreateInput = z.infer<typeof assetCreateSchema>;

export const requestAssetUploadSchema = RequestAssetUpload.http.request.body.merge(
  z.object({
    assetContent: z.nativeEnum(AssetContent).default(AssetContent.Text),
  }),
);

export type RequestAssetUploadInput = z.infer<typeof requestAssetUploadSchema>;
